module.exports = __webpack_public_path__ + "img/3.a489c69f.png";